export const INPUT_TYPE = {
  MULTI_SELECTBOX: 'MultiSelectbox',
  TEXTBOX: 'Textbox',
  DATE_RANGE: 'DateRange',
  DATE_PICKER: 'DatePicker',
}